<div
  class="equipment-data-component equipment-{{ type }} position-relative"
  [ngClass]="cardClass"
>
  <div class="row g-0 g-md-4 mt-0 p-3 pb-lg-3">
    <div class="col-lg-1 d-none d-lg-block align-self-center m-md-auto">
      <img
        *ngIf="equipmentResponse?.img"
        src="{{ baseURL + '/' + equipmentResponse.img }}"
        class="terminal-image"
        alt="{{ equipmentResponse?.serialNumber }}"
      />
    </div>
    <div class="col-12 col-lg-9 col-md-10 mt-md-0">
      <div class="row g-0 g-md-4">
        <div class="col-6 col-md-5 mb-2 order-md-1">
          <div class="text-uppercase equipment-data-label fs-6 fs-md-5">
            {{ 'terminal_terminal' | translation }}
          </div>
          <div class="equipment-data-value fw-bold fs-4 fs-md-1">
            {{ equipmentResponse?.name }}
          </div>
        </div>

        <div class="col-6 col-md-4 mb-2 order-md-2">
          <div class="text-uppercase equipment-data-label fs-6 fs-md-5">
            {{ 'terminal_serial_number' | translation }}
          </div>
          <div class="equipment-data-value fs-4">
            {{ equipmentResponse?.serialNumber }}
          </div>
        </div>

        <div class="col-6 col-md-5 mb-2 order-md-4 mt-md-0">
          <div class="text-uppercase equipment-data-label fs-6 fs-md-5">
            <ng-container *ngIf="type !== 'datalogger'">
              {{ 'terminal_system_time' | translation }}
            </ng-container>
            <ng-container *ngIf="type === 'datalogger'">
              {{ 'DL_PILLS_BATTERY' | translation }} /
              {{ 'DL_PILLS_SIGNAL' | translation }}
            </ng-container>
          </div>
          <div class="equipment-data-value fs-4">
            <ng-container *ngIf="type !== 'datalogger'">
              {{ equipmentResponse?.systemHour | transformDateTime }}
            </ng-container>
            <ng-container *ngIf="type === 'datalogger'">
              {{
                dataloggerEquipment(equipmentResponse).datalogger_configuration
                  .BATTERY
              }}
              mV /
              {{
                signalPercent(
                  dataloggerEquipment(equipmentResponse)
                    .datalogger_configuration.SIGNAL
                )
              }}
              %
            </ng-container>
          </div>
        </div>

        <div class="col-6 col-md-4 mb-2 order-md-5 mt-md-0">
          <div class="text-uppercase equipment-data-label fs-6 fs-md-5">
            {{ 'terminal_model' | translation }}
            /
            {{ 'terminal_version' | translation }}
          </div>
          <div class="equipment-data-value fs-4">
            {{ equipmentResponse?.type }}
            /
            {{ getSemanticVersioning(equipmentResponse?.warp) }}
          </div>
        </div>

        <div class="col-6 col-md-3 mb-2 order-md-3">
          <div class="text-uppercase equipment-data-label fs-6 fs-md-5">
            {{ 'terminal_last_connection' | translation }}
          </div>
          <div class="equipment-data-value fs-4">
            {{ equipmentResponse?.lastMeasure | transformDateTime }}
          </div>
        </div>

        <div class="col-6 col-md-3 mb-2 order-md-last mt-md-0">
          <div class="text-uppercase equipment-data-label fs-6 fs-md-5">
            {{ 'terminal_status' | translation }}
          </div>
          <div class="equipment-data-value fs-4">
            <span
              class="badge"
              [ngClass]="{
                'bg-danger': !equipmentResponse?.connected,
                'bg-success': equipmentResponse?.connected
              }"
            >
              {{
                equipmentResponse?.connected
                  ? ('terminal_status_connected' | translation)
                  : ('terminal_status_disconnected' | translation)
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-2 m-0 d-flex">
      <div
        class="d-flex flex-md-column flex-wrap align-items-end w-100 justify-content-end justify-content-md-between"
      >
        <a
          [routerLink]="['/edit-terminal', { vid: terminal_vid }]"
          *ngIf="hasPermissions"
          class="mb-3 col-6 col-md-auto pe-3 p-md-0"
        >
          <!-- Mobile button -->
          <ion-button size="small" class="m-0 d-flex d-md-none">
            <ion-label>{{ 'configuration_title' | translation }} </ion-label>
          </ion-button>

          <!-- Desktop button -->
          <ion-button class="d-none d-md-flex m-0">
            <ion-icon name="cog-outline"></ion-icon>
          </ion-button>
        </a>

        <a
          [routerLink]="['irrigation_installer/manual_activations']"
          *ngIf="
            type === 'irrigation' &&
            showManualActivationsLink &&
            (hasPermissions || canWrite)
          "
          class="mb-3 col-6 col-md-auto p-md-0"
        >
          <!-- Mobile button -->
          <ion-button
            size="small"
            class="d-flex d-md-none m-0 on-button-selected manual-activations-button"
          >
            {{ 'manual_activations' | translation }}
          </ion-button>

          <!-- Desktop button -->
          <ion-button class="d-none d-md-flex m-0 manual-activations-button">
            <svg
              fill="#fff"
              width="20px"
              height="20px"
              viewBox="0 0 14 14"
              role="img"
              focusable="false"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m 1.2542986,6.7932135 c -0.26947924,0.1078 -0.33977817,0.45695 -0.1359113,0.66081 l 1.2841272,1.28413 1.7152939,-0.57176 -0.5717647,1.71529 2.9994211,2.9994205 c 0.2062102,0.20621 0.5530182,0.13357 0.6608099,-0.13591 l 2.2987751,-5.7106205 -2.5401347,-2.54013 -5.7106165,2.29877 z m 11.6344734,-5.15291 -0.529586,-0.52958 c -0.145284,-0.14762997 -0.384301,-0.14762997 -0.529585,0 l -2.3971935,2.39485 -0.9466922,-0.94669 c -0.098419,-0.10077 -0.267136,-0.0703 -0.3257184,0.0586 l -0.637377,1.37317 2.4862391,2.48624 1.373172,-0.63738 c 0.126538,-0.0586 0.157001,-0.2273 0.05858,-0.32572 l -0.946693,-0.94669 2.394851,-2.39719 c 0.147627,-0.14529 0.147627,-0.38196 0,-0.52959 z"
              />
            </svg>
          </ion-button>
        </a>

        <a
          [routerLink]="['desktop']"
          *ngIf="type === 'climate' && showStateLink"
          class="mb-3 col-6 col-md-auto"
          [ngClass]="{ 'pe-3 p-md-0': !hasPermissions }"
        >
          <!-- Mobile button -->
          <ion-button color="warning" size="small" class="d-flex d-md-none m-0">
            {{ 'climate_states' | translation }}
          </ion-button>

          <!-- Desktop button -->
          <ion-button color="warning" class="d-none d-md-flex m-0">
            {{ 'climate_states' | translation }}
          </ion-button>
        </a>

        <div class="mb-3 mb-md-0 col-6 col-md-auto">
          <!-- Mobile button -->
          <ion-button
            size="small"
            class="m-0 d-flex d-md-none"
            [ngClass]="
              showNotificationsTable
                ? 'ion-button-selected'
                : 'ion-button-light'
            "
            (click)="toggleNotificationsTable()"
          >
            <ion-label
              >{{ 'notification_notifications' | translation }}
            </ion-label>
          </ion-button>

          <!-- Desktop button -->
          <ion-button
            class="d-none d-md-flex m-0"
            [ngClass]="
              showNotificationsTable
                ? 'ion-button-selected'
                : 'ion-button-light'
            "
            (click)="toggleNotificationsTable()"
          >
            <ion-icon name="notifications-outline"></ion-icon>
          </ion-button>
        </div>
      </div>
    </div>
  </div>
  <app-notifications-table
    *ngIf="showNotificationsTable"
    [terminalVids]="[terminal_vid]"
    [type]="type"
  ></app-notifications-table>
</div>
